export default "__VITE_ASSET__cde2a6d0__"